
// https://github.com/fregante/object-fit-images
import objectFitImages from 'object-fit-images';

// https://github.com/scottjehl/picturefill
import 'picturefill';

import ComponentHelper from './components/00_utilities/helpers/ComponentHelper';
import GeneralHelper from "./components/00_utilities/helpers/GeneralHelper";

/* eslint-disable */
//const __svg__ = { path: './svg/*.svg', name: 'icons/icons.svg', filename: svgFileName };
//require('webpack-svgstore-plugin/src/helpers/svgxhr')(__svg__);

if (__devMode__) {
    __webpack_public_path__ = 'http://localhost:44006/wp-content/themes/colliers/';
}

/**
 * Iterate over all dom nodes with attribute "data-component" and use it's value to dynamically import the
 * corresponding component
 */
function initComponents(parentNode = document) {
    for (const node of parentNode.querySelectorAll('[data-component]')) {
        const componentPath = ComponentHelper.prepareComponentPath(node.getAttribute('data-component'));

        if (typeof componentPath !== 'string') {
            continue; // eslint-disable-line no-continue
        }

        import(/* webpackChunkName: "[request]" */ `./components/${componentPath}`).then((Component) => {
            const comp = new Component.default(node); // eslint-disable-line new-cap
            comp.init();
        }).catch((e) => console.info(e.message)); // eslint-disable-line no-console
    }
}

//calculate window height independent of device
function setWindowInnerHeight() {
    document.body.style.setProperty('--window-inner-height', `${window.innerHeight}px`);
    window.addEventListener('resize', GeneralHelper.throttle(() => {
        document.body.style.setProperty('--window-inner-height', `${window.innerHeight}px`);
    }, 200));
}

window.addEventListener('load', () => {
    setWindowInnerHeight();
});

window.$ = jQuery;

$(window).on('load', () => {
    initComponents();

    objectFitImages();
});

/**
 * Check for hot module replacement and use it if possible
 */
if (module.hot) {
    module.hot.accept();
}
